import { PropsWithChildren, useState } from 'react';
import Modal from 'react-modal';
import { Button, Chip } from '../../../../../../components/design-system';
import { ChevronDown, Close } from '../../../../../../components/icons';
import { useTranslations } from 'next-intl';

const customStyle = {
  overlay: {
    zIndex: 999,
    backgroundColor: 'rgb(0 0 0 / 20%)',
  },
  content: {
    left: 0,
    right: 0,
    bottom: 0,
    // top: 80,
    borderWidth: '1px 0 0',
    borderColor: '#D9DBE9',
    borderRadius: '1rem 1rem 0 0',
    backgroundColor: '#ffffff',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
};

interface Props extends PropsWithChildren {
  label: string;
  appliedValue?: string;
  onApply: () => void;
}

export default function FilterModal({
  children,
  label,
  onApply,
  appliedValue,
}: Props) {
  const t = useTranslations('common');
  const [isOpen, setIsOpen] = useState(false);

  function handleApply() {
    onApply();
    setIsOpen(false);
  }

  return (
    <>
      <Chip
        active={!!appliedValue}
        className="group"
        onClick={() => setIsOpen(true)}
      >
        <span className="whitespace-nowrap">{appliedValue || label}</span>
        <ChevronDown
          className={`
          h-4 w-4 shrink-0 stroke-2 transition
          duration-150 ease-in-out group-hover:text-current/80
        `}
          aria-hidden="true"
        />
      </Chip>
      <Modal
        isOpen={isOpen}
        // @ts-ignore
        style={customStyle}
        onRequestClose={() => setIsOpen(false)}
      >
        <div className="py-2 px-4 flex items-center border-b border-greyscale-separator">
          <div className="flex-1">
            <Button
              className="-ml-4"
              palette="gray"
              theme="ghost"
              onClick={() => setIsOpen(false)}
            >
              <Close className="h-5 w-5 stroke-2" />
            </Button>
          </div>
          <h6 className="text-lg font-bold tracking-tight flex-auto mb-0 text-center">
            {label}
          </h6>
          <div className="flex-1" />
        </div>
        <div className="flex-1 overflow-y-auto py-4">{children}</div>
        <div className="px-4 pt-4 pb-6 border-t border-greyscale-separator">
          <Button variant="block" size="lg" onClick={handleApply}>
            {t('action.apply')}
          </Button>
        </div>
      </Modal>
    </>
  );
}
